import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import { initialiseAnalytics } from './lib/analytics';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ServiceDetailPage } from './pages/ServiceDetailPage';
import { PricingPage } from './pages/PricingPage';
import { StartPage } from './pages/StartPage';
import { ThanksPage } from './pages/ThanksPage';
import { PrivacyPage } from './pages/PrivacyPage';

initialiseAnalytics();

const page = document.body.dataset.page;
const serviceId = document.body.dataset.service;
const components = {
  home: <HomePage />,
  about: <AboutPage />,
  services: <ServicesPage />,
  service: <ServiceDetailPage serviceId={serviceId} />,
  pricing: <PricingPage />,
  start: <StartPage />,
  thanks: <ThanksPage />,
  privacy: <PrivacyPage />,
};

createRoot(document.getElementById('root')).render(
  <React.StrictMode>{components[page] || <HomePage />}</React.StrictMode>,
);
